import relativeDeDe from './relative-time/de-de.ts';
import relativeEn from './relative-time/en.ts';
import relativeEs from './relative-time/es.ts';
import relativeFrFr from './relative-time/fr-fr.ts';
import relativeHuHu from './relative-time/hu-hu.ts';
import relativeIt from './relative-time/it.ts';
import relativePlPl from './relative-time/pl-pl.ts';
import relativePtBr from './relative-time/pt-br.ts';
import relativeRu from './relative-time/ru.ts';
import type { Dictionary } from './types.ts';

const APP_LOCALE_MAP: Record<string, string> = {
  en: 'en',
  'en-gb': 'en',
  'en-us': 'en',
  pt: 'pt-br',
  'pt-br': 'pt-br',
  'pt-pt': 'pt-pt',
  es: 'es',
  'es-ar': 'es',
  de: 'de',
  'de-de': 'de',
  el: 'el',
  'el-gr': 'el',
  fr: 'fr',
  'fr-fr': 'fr',
  hu: 'hu',
  'hu-hu': 'hu',
  it: 'it',
  pl: 'pl',
  'pl-pl': 'pl',
  ru: 'ru'
};

export const RELATIVE_TIME_BY_LOCALE: Record<string, Dictionary<string>> = {
  en: relativeEn,
  'pt-br': relativePtBr,
  'pt-pt': relativePtBr,
  es: relativeEs,
  de: relativeDeDe,
  fr: relativeFrFr,
  hu: relativeHuHu,
  it: relativeIt,
  pl: relativePlPl,
  ru: relativeRu
};

export const mapAppLocale = (appLocale: string): string => {
  return APP_LOCALE_MAP[appLocale.toLowerCase()] ?? 'en';
};

export const mapAppLocaleToDayjs = (appLocale: string): string => mapAppLocale(appLocale);
